import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import Rest from 'tools/rest';

const CategoryFormModal = ({ visible, onClose, onSuccess, category }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isEdit = !!category?.id;

  useEffect(() => {
    if (!visible) return;
    if (category?.id) {
      form.setFieldsValue({ name: category.name });
    } else {
      form.resetFields();
    }
  }, [visible, category, form]);

  const handleOk = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      const payload = { material_category: { name: values.name.trim() } };
      const req = isEdit
        ? Rest.put(`/api/v1/material_categories/${category.id}.json`, payload)
        : Rest.post('/api/v1/material_categories.json', payload);

      req
        .then((r) => {
          const cat = r.data?.material_category;
          if (cat?.id) {
            message.success(isEdit ? 'Категория сохранена' : 'Категория добавлена');
            onSuccess(cat);
            onClose();
          } else {
            const errs = r.data?.errors;
            message.error(
              typeof errs === 'object'
                ? Object.values(errs).flat().join(', ')
                : 'Не удалось сохранить'
            );
          }
        })
        .catch((err) => {
          const d = err.response?.data;
          let msg = err.message || 'Ошибка';
          if (d?.errors) {
            msg = Array.isArray(d.errors)
              ? d.errors.join(', ')
              : Object.values(d.errors).flat().join(', ');
          }
          message.error(msg);
        })
        .finally(() => setLoading(false));
    });
  };

  return (
    <Modal
      title={isEdit ? 'Редактирование категории' : 'Новая категория'}
      open={visible}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={loading}
      okText="Сохранить"
      cancelText="Отмена"
      destroyOnHidden
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="name"
          label="Название"
          rules={[{ required: true, message: 'Введите название' }]}
        >
          <Input placeholder="Название категории" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryFormModal;
